<template>
  <drawer-layout>
    <main class="bible">
      <ControlPanelUsers v-if="!isLoading" />
      <!-- <ControlPanelSkeletons v-if="isLoading" :users="true" />-->


      <UsersTableSkeleton v-if="isLoading" />
      <UsersTable :users="allUsers" v-if="!isLoading"/>
    </main>
  </drawer-layout>
</template>

<script>
import DrawerLayout from "../../Shared/DrawerLayout.vue";
import ControlPanelUsers from "../../Shared/Users/ControlPanelUsers.vue";
import UsersTable from "../../Shared/Users/UsersTable.vue"
import UsersTableSkeleton from "../../Shared/Users/UsersTableSkeleton.vue";
import { mapGetters } from 'vuex';

export default {
    components: { DrawerLayout, ControlPanelUsers, UsersTable, UsersTableSkeleton },
    props: {
      allUsers: {
        type: Array,
        default: null,
      },
    },
    computed:{
      ...mapGetters({
        isLoading:"users/getIsLoading"
      })
    }
}
</script>
